import PosthogService from '~/services/posthog/PosthogService';

export interface IOpenShiftAutoconfirmFavoriteSelectedPayload {
  autoConfirm: 'on' | 'off';
  designDate: number;
}

/**
 * Fires when a user turns autoconfirm favorites ON/OFF on the open shift edit page
 * Event: dental_portal:open_shift:autoconfirm_favorite_selected
 */
export function fireOpenShiftAutoconfirmFavoriteSelected(
  payload: IOpenShiftAutoconfirmFavoriteSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:open_shift:autoconfirm_favorite_selected',
    {
      'auto-confirm': payload.autoConfirm,
      design_date: payload.designDate,
    },
  );
}
